var React = require('react');

function InfoStrokeIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFFFFF","cx":"12","cy":"12","r":"8","key":0}),React.createElement("path",{"fill":"currentColor","d":"m12 2a10 10 0 1 0 10 10 10 10 0 0 0 -10-10zm0 18a8 8 0 1 1 8-8 8.00905 8.00905 0 0 1 -8 8z","key":1}),React.createElement("path",{"fill":"currentColor","d":"m12.00049 9.12174a1.06126 1.06126 0 1 1 1.09-1.06476 1.03818 1.03818 0 0 1 -1.09 1.06476zm-.91891 1.50039c0-.38992.07877-.69428.91891-.69428.83916 0 .91793.30436.91793.69428v5.68359c0 .38992-.07877.69428-.91793.69428-.84014 0-.91891-.30436-.91891-.69428z","key":2})]);
}

InfoStrokeIcon.defaultProps = {"data-dmid":"dm-info-stroke","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = InfoStrokeIcon;

InfoStrokeIcon.default = InfoStrokeIcon;
